// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.MenuCard-colorSelector {\n    height: 1.5em;\n    width: 1.5em;\n    outline: none;\n}\n\n.MenuCard-fullHeight {\n    max-height: 100%;\n    overflow: auto;\n}\n\n.ios .product-form-col {\n    overflow-y: scroll;\n    -webkit-overflow-scrolling: touch;\n}\n\n.form-toggle-row {\n    padding: 1rem 0 .5rem 0;\n}\n", ""]);
// Exports
module.exports = exports;
